module.exports = __webpack_public_path__ + "img/AlcoholRaisedHP.adb5fbae.png";